module.exports = __webpack_public_path__ + "static/media/mouthpiece.f5ea1f25.png";